
<form [formGroup]="formGroup">
  <label for="folderId"><h4><mat-icon>description</mat-icon>&nbsp;Agiris / Isacompta / Isagri</h4></label>
  <div class="row">
    <mat-form-field>
      <mat-label>Identifiant dossier</mat-label>
      <input matInput formControlName="folderId" placeholder="000001">
    </mat-form-field>
  </div>
  <!--<div class="row">
    <mat-slide-toggle formControlName="withPublicUrl">
      <div>
        <span>Ajouter l'url publique de la PJ (si l'outils en fourni une)</span>
      </div>
    </mat-slide-toggle>
  </div>-->
  <app-basic-load-configuration-options
    [formGroup]="formGroup"
    [configuration]="configuration"
    [configurationMode]="configurationMode">
  </app-basic-load-configuration-options>
</form>